import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'

import SocialButton from '../../Common/SocialButton/SocialButton'

const cn = bem({ prefix: 'lc-', block: 'end-prompt' })

const defaultMessage = '<div>Thanks for chatting with us today.</div>'

export const EndPrompt = ({ message, alternateChannels = {} }) => {
  const endMessage = message || defaultMessage

  const { facebook = {}, telephone = {}, twitter = {} } = alternateChannels
  const showFacebook = facebook.enabled && facebook.url
  const showTelephone = telephone.enabled && telephone.number
  const showTwitter = twitter.enabled && twitter.url

  return (
    <div className={`${cn()} lc-controls__form lc-controls__form--with-seperator`}>
      <div className={cn('message')} dangerouslySetInnerHTML={{ __html: `${endMessage}` }} />
      {(showFacebook || showTwitter) && (
        <div className={cn('social-buttons')}>
          {showFacebook && <SocialButton type='Facebook' url={facebook.url} />}
          {showTwitter && <SocialButton type='Twitter' url={twitter.url} />}
        </div>
      )}
      {showTelephone && (
        <a href={`tel:${telephone.number}`} className={cn('phone')}>
          {telephone.number}
        </a>
      )}
    </div>
  )
}

EndPrompt.propTypes = {
  message: PropTypes.string,
  alternateChannels: PropTypes.shape({
    facebook: PropTypes.shape({
      enabled: PropTypes.bool,
      url: PropTypes.string,
    }),
    telephone: PropTypes.shape({
      enabled: PropTypes.bool,
      number: PropTypes.string,
    }),
    twitter: PropTypes.shape({
      enabled: PropTypes.bool,
      url: PropTypes.string,
    }),
  }),
}

export default EndPrompt
